import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResetPassword = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_362_6581)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_362_6581",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_362_6581)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12.0085 21.0999C10.7567 21.0999 9.57952 20.8643 8.47702 20.3932C7.37436 19.922 6.40677 19.272 5.57427 18.4432C4.74194 17.6145 4.08811 16.6496 3.61277 15.5484C3.13761 14.4474 2.90002 13.271 2.90002 12.0192H4.20002C4.20002 13.0858 4.40536 14.0931 4.81602 15.0409C5.22686 15.9889 5.78686 16.8165 6.49602 17.5237C7.20502 18.2308 8.03219 18.787 8.97753 19.1922C9.92286 19.5973 10.9287 19.7999 11.995 19.7999C14.165 19.7999 16.0084 19.0416 17.525 17.5249C19.0417 16.0082 19.8 14.1666 19.8 11.9999C19.8 9.83324 19.0417 7.99157 17.525 6.4749C16.0084 4.95824 14.1667 4.1999 12 4.1999C10.5462 4.1999 9.22502 4.55699 8.03652 5.27115C6.84802 5.98515 5.91986 6.93707 5.25202 8.1269H7.62702V9.4269H2.90002V4.6999H4.20002V7.3904C4.98719 6.03907 6.06477 4.95282 7.43277 4.13165C8.80094 3.31049 10.3234 2.8999 12 2.8999C13.2642 2.8999 14.445 3.13674 15.5425 3.6104C16.64 4.08407 17.6038 4.73582 18.4338 5.56565C19.2638 6.39549 19.9156 7.3609 20.3893 8.4619C20.8631 9.56307 21.1 10.7396 21.1 11.9914C21.1 13.2432 20.8632 14.4222 20.3895 15.5284C19.9159 16.6346 19.2641 17.6027 18.4343 18.4329C17.6044 19.2631 16.639 19.9152 15.538 20.3892C14.4369 20.863 13.2604 21.0999 12.0085 21.0999ZM10.207 15.4844C9.96869 15.4844 9.76753 15.4039 9.60353 15.2429C9.43969 15.0817 9.35777 14.8821 9.35777 14.6439V11.9489C9.35777 11.7107 9.44419 11.5107 9.61702 11.3489C9.78986 11.1871 10.0041 11.1062 10.2598 11.1062V10.1464C10.2598 9.66607 10.4307 9.2549 10.7725 8.9129C11.1145 8.5709 11.5257 8.3999 12.006 8.3999C12.4862 8.3999 12.8962 8.57049 13.236 8.91165C13.5759 9.25282 13.7458 9.66299 13.7458 10.1422V11.0999C13.9998 11.0999 14.2127 11.1807 14.3845 11.3422C14.5564 11.5035 14.6423 11.7035 14.6423 11.9422V14.6422C14.6423 14.8808 14.5617 15.0809 14.4005 15.2424C14.2394 15.4037 14.0397 15.4844 13.8015 15.4844H10.207ZM11.0423 11.0999H12.9578V10.1512C12.9578 9.88232 12.8656 9.65399 12.6813 9.46615C12.4969 9.27832 12.2716 9.1844 12.0053 9.1844C11.7389 9.1844 11.5119 9.27707 11.324 9.4624C11.1362 9.64774 11.0423 9.87557 11.0423 10.1459V11.0999Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_362_6581",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgResetPassword;
